import { residentialWasteRecyclingPickUpDataFr } from "constants-lib/seo/residentialWasteRecyclingPickUpData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getResidentialWasteRecyclingPickUpFr = () => {
  const data = residentialWasteRecyclingPickUpDataFr.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addResidentialWasteRecyclingPickUp = () => {
  if (
    window.location.href.includes(
      `/ca/fr/home/residential-waste-recycling-pickup`,
    ) &&
    document.getElementById(`residentialWasteRecyclingPickUpJSONLD`) === null
  ) {
    const script = ResidentialWasteRecyclingPickUpJSONLDFr()
    addJSONLDToHead(script, `residentialWasteRecyclingPickUpJSONLD`)
  } else {
    removeElement(`residentialWasteRecyclingPickUpJSONLD`)
  }
}

const ResidentialWasteRecyclingPickUpJSONLDFr = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getResidentialWasteRecyclingPickUpFr(),
  }
  return FaqBagsterTemplate
}
